import { render, staticRenderFns } from "./postedProducts.vue?vue&type=template&id=41084a32&scoped=true"
import script from "./postedProducts.vue?vue&type=script&lang=js"
export * from "./postedProducts.vue?vue&type=script&lang=js"
import style0 from "./postedProducts.vue?vue&type=style&index=0&id=41084a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41084a32",
  null
  
)

export default component.exports